<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <div class="d-flex align-center justify-space-between textColor rounded-lg px-4 py-2">
        <p class="sm-font300-14 primary--text mb-0">تعریف دوره مادر</p>
        <v-icon>mdi-chevron-left</v-icon>
      </div>
      <div class="textColor px-6 py-8 rounded-lg mt-3">
        <v-stepper v-model="courseStep" alt-labels elevation="0">
          <v-stepper-header>
            <v-stepper-step
                :complete="courseStep === 1"
                step=""
                complete-icon=""
                @click="courseStep = 1"
            >
              ایستگاه
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="courseStep === 2"
                step=""
                complete-icon=""
                @click="courseStep = 2"
            >
              برنامه
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="courseStep === 3"
                step=""
                complete-icon=""
                @click="courseStep = 3"
            >
              حرکت
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <Infos :formType="'edit'" :contentData="stepData" v-if="!loading" @nextStep="nextStep"/>
            </v-stepper-content>

            <v-stepper-content step="2">
              <Plans v-if="courseStep === 2" @nextStep="nextStep"/>
            </v-stepper-content>

            <v-stepper-content step="3">
              <Actions v-if="courseStep === 3" />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>

    </v-card>
  </v-container>
</template>

<script>
import Plans from "@/components/Courses/Course/forms/bootcamp/plans.vue";
import Actions from "@/components/Courses/Course/forms/bootcamp/actions.vue";
import Infos from "@/components/Courses/Course/forms/bootcamp/infos.vue";
import courseApi from '@/Services/modules/courses'

export default {
  name: "createCoaching",
  components: {Actions, Plans, Infos},
  data() {
    return {
      courseStep: Number(this.$route.query.step) || 1,
      stepData: {},
      loading: false
    }
  },
  methods: {
    async getData() {
      this.loading = true
      await courseApi.getBaseCourseById(this.$route.params.id).then(res => {
        this.stepData = res.data
        this.loading = false
      })
    },
    nextStep(val) {
      this.courseStep = val
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>

</style>